<template lang="pug">
.catalogPageComponent( :class="menuClass")
  .headerWrapper
    .pageTitle Витрина

    .filtersButtonWrapper
      ui-svg-icon.filtersButton(
        :name="filtersButtonIcon"
        originalColors
        @click="toggleFilterMenu"
      )

    .favoriteFilter
      ui-badge-select(
        v-if="isAuthenticated"
        variant='catalog'
        v-model="filters.favorite"
        :options="favoriteFilterOptions"
        :allowEmpty="true"
        :isMultiple="false"
      )

    search-component.searchFilter(v-model="filters.search")

  .container
    filters-component.filters(
      v-model:selectedLevel="filters.selectedLevel"
      v-model:selectedTypes="filters.selectedTypes"
      v-model:selectedSubjects="filters.selectedSubjects"
      @action:reset="onResetFilters")

    .content
      ui-loader(v-if="isLoading")
      .catalog(v-else-if="bundleItems.length || vprsItems.length")
        template(v-if="bundleItems.length")
          .bundle(
            v-for="bundle in bundleItems"
            :key="bundle.label"
          )
            .bundleTitle {{ bundle.label }}
            .itemsWrapper
              .items
                ui-user-item.card(
                  v-for="userItem in bundle.items"
                  :key="userItem.id"
                  variant="catalog"
                  :userItem="userItem"
                  :showFavorite="isAuthenticated"
                  @action:click-on-item="userItem.goToContents()"
                )
              .bundleFooter
                template(v-if="getIsInBasket(bundle.nomenklatura)")
                  .textBasket Уже в корзине
                template(v-else)
                  ui-price(
                    v-if="!bundle.bought"
                    variant="button"
                    text="В корзину за"
                    :price="bundle.price"
                    :old-price="bundle.oldPrice"
                    @click="isAuthenticated ? addToBasket(bundle.nomenklatura) : login()"
                  )
                template(v-if="!bundle.bought")
                  .text При покупке предоставляется доступ на 1 год ко всем учебникам предмета для 1 класса
                  //.text Материалы для 2 класса станут доступны 01.07.2022
                template(v-if="subscription?.isDemo && !bundle.bought")
                  .text Демо-доступ до {{ subscription.expires }}
                template(v-else-if="bundle.bought")
                  .text Подписка активна до {{ bundle.expires }}
                    //.text Материалы для 2 класса станут доступны 01.07.2022
              //.showMoreWrapper(v-if="hasMoreItems")
              //  ui-button(
              //    v-if="!isLoadingMoreItems"
              //    @click="getMoreItems"
              //  ) Показать ещё
              //  ui-loader(v-else)

        template(v-if="vprsItems.length")
          .bundle
            .bundleTitle &nbsp;
            .itemsWrapper
              .items
                ui-user-item.card(
                  v-for="userItem in vprsItems"
                  :key="userItem.id"
                  variant="catalog"
                  :user-item="userItem"
                  :show-buy-button="true"
                  :show-favorite="isAuthenticated"
                  :is-in-basket="getIsInBasket(userItem.nomenklatura)"
                  @action:click-on-buy="isAuthenticated ? addToBasket(userItem.nomenklatura) : login()"
                  @action:click-on-item="userItem.goToContents()"
                )
              //.showMoreWrapper(v-if="hasMoreItems")
              //  ui-button(
              //    v-if="!isLoadingMoreItems"
              //    @click.native="getMoreItems"
              //  ) Показать ещё
              //  ui-loader(v-else)
      p(v-else) По заданным фильтрам материалы отсутствуют.
</template>

<script>
import { BOOKS_PER_PAGE_CATALOG_DESKTOP } from '@/config'
import CatalogController from '@/controllers/CatalogController'
import SearchComponent from '@/components/Search.vue'
import FiltersComponent from '@/components/Catalog/CatalogFilters.vue'
import useFlag from '@/_core/hooks/useFlag'
import useWindowBreakpointCallback from '@/_core/hooks/useWindowBreakpointCallback'
import { computed, ref, watch, inject } from 'vue'

const initialFilter = {
  selectedLevel: null,
  selectedSubjects: [],
  selectedTypes: [],
  search: null,
  favorite: null
}

export default {
  components: {
    SearchComponent,
    FiltersComponent
  },
  setup () {
    const store = inject('store')
    const subscription = computed(() => store.user.profile?.subscription)
    const isAuthenticated = computed(() => store.user.isAuthenticated)
    const login = store.user.login
    const hasSubscriptions = computed(() => store.user.profile.hasSubscriptions)

    // Mobile Filters menu logic
    const {
      flag: isMobileMenuOpened,
      cssClass: menuClass,
      toggle: toggleFilterMenu,
      off: closeFilterMenu
    } = useFlag('_mobileFiltersOpened', false)

    const filtersButtonIcon = computed(() => (isMobileMenuOpened.value ? 'close' : 'filter'))

    const handleOverflow = isOpened => {
      document.querySelector('body').style.overflow = isOpened ? 'hidden' : ''
      document.querySelector('#app').style.overflow = isOpened ? 'hidden' : ''
    }

    watch(isMobileMenuOpened, handleOverflow)

    useWindowBreakpointCallback(825, handleOverflow, closeFilterMenu, isMobileMenuOpened.value)

    // Catalog Items logic
    const {
      items,
      vprsItems,
      bundleItems,
      hasMoreItems,
      setFilter,
      requestItems,
      requestGetMoreItems,
      isLoading,
      isLoadingMoreItems
    } = CatalogController(BOOKS_PER_PAGE_CATALOG_DESKTOP)

    requestItems()

    // Filters logic
    const filters = ref({ ...initialFilter })
    const resetFilters = () => {
      filters.value = { ...initialFilter }
    }

    watch(
      filters,
      val => {
        setFilter({
          level: val.selectedLevel,
          subjects_id: val.selectedSubjects,
          types: val.selectedTypes,
          search: val.search,
          favorite: val.favorite ? true : null
        })
      },
      { deep: true }
    )

    const getIsInBasket = (nomenklatura) => {
      return store.basket.data?.items.find(o => o.nomenklatura === nomenklatura)
    }

    const addToBasket = (nomenklatura) => {
      if (!getIsInBasket(nomenklatura)) {
        store.basket.addProducts([nomenklatura])
      }
    }

    // Output
    return {
      getIsInBasket,
      addToBasket,
      items,
      vprsItems,
      bundleItems,
      isLoading,
      hasMoreItems,
      getMoreItems: requestGetMoreItems,
      isLoadingMoreItems,
      filters,
      onResetFilters: resetFilters,
      isMobileMenuOpened,
      menuClass,
      toggleFilterMenu,
      filtersButtonIcon,
      isAuthenticated,
      login,
      subscription,
      hasSubscriptions
    }
  },
  data () {
    return {
      favoriteFilterOptions: [
        {
          value: 1,
          label: 'Избранное',
          icon: 'bookmark'
        }
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
.catalogPageComponent
  > .headerWrapper
    width: 100%
    display: grid
    grid-template-columns: repeat(2, 1fr)
    grid-template-rows: repeat(2, 1fr)
    column-gap: 5*$u
    row-gap: 7.5*$u
    margin-bottom: 10*$u

    > .pageTitle
      @include font('h1')

    > .filtersButtonWrapper
      margin-left: auto
      width: 9*$u
      height: 10*$u
      > .filtersButton
        display: none
        cursor: pointer

    > .favoriteFilter
      &:deep(.badgeSelectComponent ._selected path)
        stroke: $cWhite !important

    > .searchFilter
      align-self: center
      margin-left: auto

  > .container
    display: flex
    flex-direction: row
    @include gap2d(7.5*$u)

    > .filters
      flex: 0 0 84*$u
      border-radius: 5*$u

    > .content
      flex: 1

      .catalog
        .bundle
          margin-bottom: 7*$u
          border-bottom: 2px solid $cDarkBackground
          &:last-child
            border: 0
            margin-bottom: 0
          .bundleTitle
            @include font('h2')
            margin-bottom: 4*$u
          .bundleFooter
            margin: 7*$u 0
            .textBasket
              white-space: nowrap
              cursor: default
              height: 11.5*$u
              padding: 0 3*$u
              margin-bottom: 2*$u
              display: flex
              width: 32*$u
              justify-content: center
              align-items: center
              background-color: $cHtBlue
              color: $cDarkGrey
              border-radius: 2.5*$u
            .button
              margin-bottom: 2*$u
            .text
              color: $cDarkGrey
              @include font('t16-regular')

      .itemsWrapper
        > .items
          display: grid
          grid-template-columns: repeat(3, 1fr)
          grid-gap: 7.5*$u
          @media (max-width: $XXXLWidth)
            grid-template-columns: repeat(2, 1fr)
          @media (max-width: 970px)
            grid-template-columns: repeat(1, 1fr)
          @media (max-width: $padWidth)
            grid-template-columns: repeat(2, 1fr)
          @media (max-width: $SWidth)
            grid-template-columns: repeat(1, 1fr)

        > .showMoreWrapper
          width: fit-content
          margin-top: 12.5*$u

  @media (max-width: $padWidth)
    > .headerWrapper
      row-gap: 6*$u
      margin-bottom: 7*$u

      > .pageTitle
        @include font('m-h1')

      > .filtersButtonWrapper
        > .filtersButton
          display: block

      > .searchFilter
        display: none

    > .container
      @include gap2d(0px)
      margin-left: 0

      > .filters
        display: none

    &._mobileFiltersOpened
      > .headerWrapper
        width: 100%
        position: absolute
        top: 16*$u
        left: 0
        z-index: 60
        grid-template-rows: repeat(1, 1fr)
        background-color: $cWhite
        padding: 5*$u $appSidePaddingMobile
        margin: 0

        > .pageTitle
          display: none
        > .searchFilter
          grid-column: 1 / 2
          grid-row: 1 / 2
          position: relative
          top: 0
          left: -3.5*$u
          z-index: 60
          display: flex
          margin-left: 0

        > .filtersButtonWrapper
          position: relative
          z-index: 60
          padding: 2.5*$u
          left: $u

        > .favoriteFilter
          display: none

      > .container
        > .filters
          overflow-y: auto
          width: 100vw
          height: calc(100vh - 64px)
          position: absolute
          top: 16*$u
          left: 0
          z-index: 50
          display: flex
          flex-direction: column
          border-radius: 0
          padding: 25*$u $appSidePaddingMobile 5*$u

  @media (max-width: $mobileWidth)
    > .container
      > .filters
        padding: 16*$u $appSidePaddingMobile 5*$u !important

    &._mobileFiltersOpened
      > .headerWrapper
        top: 15*$u !important
        padding: 4*$u $appSidePaddingMobile

        > .filtersButtonWrapper
          width: 9*$u
          height: 9*$u
          top: $u
</style>
